<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Kidnapped By the Taliban: A Story of Terror, Hope, and Rescue By Seal Team Six</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct1" id="p0009-01-0"><a id="pageix">CONTENTS</a></p><a id="pageix">
</a><p class="cct11" id="p0009-02-1"><a id="pageix"><i></i></a><i><a href="#/chapter3#cap0" id="con0">Prologue: Kidnapped</a></i></p>
<p class="cctt" id="p0009-03-3"><a href="#/chapter4#cap1" id="con1">1. Finding My Way</a></p>
<p class="cctt" id="p0009-P-1"><span href="#/chapter5#cap2" id="con2" title="Link target outside of Sample">2. Afghanistan</span></p>
<p class="cctt" id="p0009-P-2"><span href="#/chapter6#cap3" id="con3" title="Link target outside of Sample">3. Anguish and Peace</span></p>
<p class="cctt" id="p0009-P-3"><span href="#/chapter7#cap4" id="con4" title="Link target outside of Sample">4. Taliban Hospitality</span></p>
<p class="cctt" id="p0009-P-4"><span href="#/chapter8#cap5" id="con5" title="Link target outside of Sample">5. Bad News</span></p>
<p class="cctt" id="p0009-P-5"><span href="#/chapter9#cap6" id="con6" title="Link target outside of Sample">6. “We’re Going to Kill You”</span></p>
<p class="cctt" id="p0009-P-6"><span href="#/chapter10#cap7" id="con7" title="Link target outside of Sample">7. Whatever This Is</span></p>
<p class="cctt" id="p0009-P-7"><span href="#/chapter11#cap8" id="con8" title="Link target outside of Sample">8. Demands</span></p>
<p class="cctt" id="p0009-P-8"><span href="#/chapter12#cap9" id="con9" title="Link target outside of Sample">9. The Conversation</span></p>
<p class="cct" id="p0009-P-9"><span href="#/chapter13#cap10" id="con10" title="Link target outside of Sample">10. Connections</span></p>
<p class="cct" id="p0009-P-10"><span href="#/chapter14#cap11" id="con11" title="Link target outside of Sample">11. A Precarious Peace</span></p>
<p class="cct" id="p0009-P-11"><span href="#/chapter15#cap12" id="con12" title="Link target outside of Sample">12. Shifting Demands</span></p>
<p class="cct" id="p0009-P-12"><span href="#/chapter16#cap13" id="con13" title="Link target outside of Sample">13. “Papa’s in Trouble”</span></p>
<p class="cct" id="p0009-P-13"><span href="#/chapter17#cap14" id="con14" title="Link target outside of Sample">14. On the Run</span></p>
<p class="cct" id="p0010-01-0"><a id="pagex"></a><span href="#/chapter18#cap15" id="con15" title="Link target outside of Sample">15. The Taliban Dry My Tears</span></p>
<p class="cct" id="p0010-P-1"><span href="#/chapter19#cap16" id="con16" title="Link target outside of Sample">16. The Last Night</span></p>
<p class="cct" id="p0010-P-2"><span href="#/chapter20#cap17" id="con17" title="Link target outside of Sample">17. Rescue</span></p>
<p class="cct" id="p0010-P-3"><span href="#/chapter21#cap18" id="con18" title="Link target outside of Sample">18. Reborn</span></p>
<p class="cct" id="p0010-P-4"><span href="#/chapter22#cap19" id="con19" title="Link target outside of Sample">19. Home</span></p>
<p class="cct12" id="p0010-02-2"><i><span href="#/chapter23#cap20" id="con20" title="Link target outside of Sample">Epilogue: Heartache and Joy</span></i></p>
<p class="cct1" id="p0010-P-5"><span href="#/chapter24#cap21" id="con21" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
<p class="cct1" id="p0010-P-6"><span href="#/chapter25#cap22" id="con22" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="cct1" id="p0010-P-7"><span href="#/chapter26#cap23" id="con23" title="Link target outside of Sample"><i>Glossary</i></span></p>
<p class="cct1" id="p0010-P-8"><span href="#/chapter27#cap24" id="con24" title="Link target outside of Sample"><i>Recommended Resources</i></span></p>
<p class="cct1" id="p0010-P-9"><span href="#/chapter28#cap25" id="con25" title="Link target outside of Sample"><i>About the Authors</i></span></p>
<p class="cct1"><span href="#/forward3#cap26" id="con26" title="Link target outside of Sample"><i>Photos</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0b191c8c